import React from "react";
import createSvgIcon from "../utils/createSvgIcon";
export default createSvgIcon(React.createElement(React.Fragment, null, React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.92385 4.01988C7.18903 3.70167 7.66195 3.65868 7.98016 3.92385L16.9802 11.4239C17.1512 11.5663 17.25 11.7774 17.25 12C17.25 12.2226 17.1512 12.4337 16.9802 12.5762L7.98016 20.0762C7.66195 20.3414 7.18903 20.2984 6.92385 19.9802C6.65868 19.662 6.70167 19.189 7.01988 18.9239L15.3285 12L7.01988 5.07618C6.70167 4.81101 6.65868 4.33809 6.92385 4.01988Z"
})), "IconChevronRight");